export enum PermissionEnum {
  writeResident = 'write:resident',
  readResident = 'read:resident',
  updateResident = 'update:resident',
  readTrafficLog = 'read:traffic_log',
  writeIncidentReport = 'write:incident_report',
}
